module.exports = __webpack_public_path__ + "static/vib_play1-aae35942da417125931af78912e6ea28.jpg";